import React from 'react';
import PropTypes from 'prop-types';
/**
 * Delay the rendering of content with a certain amount of time (in ms).
 * Once the delay has passed, this component's `children` are rendered as is.
 */
export default class DelayRenderComponent extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      waiting: props.delay > 0
    };
  }

  componentDidMount() {
    const { waiting } = this.state;
    const { delay } = this.props;
    if (waiting) {
      this.timer = setTimeout(() => {
        this.setState({
          waiting: false
        });
      }, delay);
    }
  }

  componentWillUnmount() {
    clearTimeout(this.timer);
  }

  render() {
    const { waiting } = this.state;
    const { children } = this.props;
    if (!waiting) return children;
    return null;
  }
}

DelayRenderComponent.propTypes = {
  delay: PropTypes.number,
  children: PropTypes.node.isRequired
};

DelayRenderComponent.defaultProps = {
  delay: 0
};
